import { Notyf, INotyfOptions, NotyfNotification } from "../../node_modules/notyf/notyf.es.min.js";
import { cssTagLoader } from "./script-tag-loader.js";
import { getModuleRelativePath } from "./url-utils.js";

export class Notify {
    private static instance: Notify;
    private options: INotyfOptions;
    private notyf: Notyf;

    constructor() {
        
        if (!Notify.instance) {
            Notify.instance = this;
            this._initNoty();
        }
        return Notify.instance as Notify;
    }

    /* #region  Public */

    public error(message: string, nextPageLoad: boolean = false): NotyfNotification {
        if (nextPageLoad) {
            this.enqueueForNextPageLoad("error", message);
            return null;
        }

        return this.notyf.error({
            type: 'error',
            message: message,
            duration: 14000
        });
    }

    public success(message: string, nextPageLoad: boolean = false): NotyfNotification {
        if (nextPageLoad) {
            this.enqueueForNextPageLoad("success", message);
            return null;
        }

        return this.notyf.success(message);
    }

    public warning(message: string, nextPageLoad: boolean = false): NotyfNotification {
        if (nextPageLoad) {
            this.enqueueForNextPageLoad("warning", message);
            return null;
        }

        return this.notyf.open(
            {
                type: 'warning',
                message: message,
                className: 'notyf__toast--warning',
                duration: 10000
            }
        );
    }

    public static getInstance(): Notify {
        if (!Notify.instance) {
            Notify.instance = new Notify();
        }
        return Notify.instance;
    }

    /* #endregion */

    /* #region Private */
    private _initNoty() {
        cssTagLoader(getModuleRelativePath(import.meta.url, "../../node_modules/notyf/notyf.min.css"));

        this.options = {
            duration: 7000,
            ripple: false, //While we do use jQuery Noty we have to disable ripple effect at notyF, to have more consistent look and feel.
            position: {
                x: "center",
                y: "top"
            },
            types: [
                {
                  type: 'warning',
                  background: 'orange',
                  icon: {
                    className: 'notyf__icon--warning',
                    tagName: 'i',
                    text: 'warning'
                  }
                }
              ],
            dismissible: true
        } as INotyfOptions;

        this.notyf = new Notyf(this.options);

        const notifyNextPageLoad = this.dequeueForNextPageLoad();
        notifyNextPageLoad?.forEach((n: { type: string, message: string }) => {
            this[n.type](n.message);
        });
    }

    private enqueueForNextPageLoad(type: string, message: string) {
        const localStorageItem = localStorage.getItem("notify_next_page_load");
        const notifyNextPageLoad = localStorageItem?.length ? JSON.parse(localStorageItem) : [];
        notifyNextPageLoad.push({ type: type, message: message });
        localStorage.setItem("notify_next_page_load", JSON.stringify(notifyNextPageLoad));
    }

    private dequeueForNextPageLoad() {
        const localStorageItem = localStorage.getItem("notify_next_page_load");
        const notifyNextPageLoad = localStorageItem?.length ? JSON.parse(localStorageItem) : [];
        localStorage.removeItem("notify_next_page_load");
        return notifyNextPageLoad;
    }
    /* #endregion */
}